import ProductsFooter from "./ProductsFooter";

export default ProductsFooter;
